import React, {useState, useMemo} from "react";
import {useHistory} from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./PublicEventContent.scss";
import classnames from "classnames";
import moment from "moment";
import Video from "components/shared/elements/Video";
import {postify} from "utils/postUtils";
import {eventFormat} from "utils/dateFormatter";

export default function EventContent(props) {
    const eventText = useMemo(() => postify(props.event.text || ""), [props.event.text]);
    const history = useHistory();
    const backToDate = () => {
        history.push(`/calendar/${moment(props.event.eventDate).format("YYYY-MM-DD")}`);
    }
    return (
        <div className={styles.root}>
            <div className={styles.eventDate} onClick={backToDate}>
                <div className={classnames(styles.iconStack)}>
                    <i className="fal fa-calendar-alt" />
                    {new Date(props.event.eventDate) <= new Date() &&
                        <i className={classnames(styles.pastEventIcon, "fas fa-clock")} />
                    }
                </div>
                <span>{eventFormat(props.event.eventDate)}</span>
            </div>
            <h2 className={styles.title}>{props.event.title}</h2>
            <div>
                {!!props.event.image && (
                    <div className={styles.postImage}>
                        <img src={props.event.image.file} />
                    </div>
                )}

                {!!props.event.video && (
                    <div>
                        <Video
                            muxPlaybackId={props.event.video.muxPlaybackId}
                            thumbnailTimecode={props.event.video.thumbnailTimecode || null}
                            analyticsData= {{
                                title: props.event.title,
                            }}
                        />
                    </div>
                )}
                <div
                    className={styles.text}
                     dangerouslySetInnerHTML={{__html: eventText}}
                />
            </div>
        </div>
    );
}

EventContent.propTypes = {
    event: PropTypes.object.isRequired,
};
